module.exports = __webpack_public_path__ + "img/da9cd0c.webp";